<div *ngIf="CONTENT_BOUNDS && !isLoading">
  <form [formGroup]="form">
    <div class="voxel-row-4">
      <div class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-2 voxel-col-md-2" *ngIf="isVisible('customer_type')">
        <voxel-form-field [label]="CONTENT_BOUNDS?.customer_type?.label"
          [msgErr]="CONTENT_BOUNDS?.customer_type?.msgErr">
          <input
            type="text"
            voxelInput
            voxelAutocomplete
            #includesFilterInput="voxelAutocomplete"
            [formControlName]="CONTENT_BOUNDS?.customer_type?.formControlName"
          />
          <app-clean-autocomplete [autocomplete]="customerTypesAutocomplete"></app-clean-autocomplete>
          <voxel-autocomplete #customerTypesAutocomplete [input]="includesFilterInput" filterMode="includes">
            <voxel-option value="" [innerText]="CONTENT_BOUNDS?.customer_type?.initialOption"></voxel-option>
            <voxel-option *ngFor="let option of customerTypesList" [value]="option.id"
            [innerText]="option.desc">
            </voxel-option>
          </voxel-autocomplete>
        </voxel-form-field>
      </div>
      <div class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-2 voxel-col-md-2">
        <voxel-form-field [label]="CONTENT_BOUNDS?.solicitation_type?.label"
          [msgErr]="CONTENT_BOUNDS?.solicitation_type?.msgErr">
          <input
          [placeholder]="CONTENT_BOUNDS?.solicitation_type?.initialOption"
            type="text"
            voxelInput
            voxelAutocomplete
            #filterCellType="voxelAutocomplete"
            [formControlName]="CONTENT_BOUNDS?.solicitation_type?.formControlName"
          />
          <app-clean-autocomplete [autocomplete]="typesAutocomplete"></app-clean-autocomplete>
          <voxel-autocomplete #typesAutocomplete [input]="filterCellType" filterMode="includes">
            <!--<voxel-option value="" [innerText]="CONTENT_BOUNDS?.solicitation_type?.initialOption"></voxel-option>-->
            <voxel-option *ngFor="let option of celulaTypesList" [value]="option.id"
            [innerText]="option.name">
            </voxel-option>
          </voxel-autocomplete>
        </voxel-form-field>
      </div>

      <div class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-2 voxel-col-md-2">
        <voxel-form-field [label]="CONTENT_BOUNDS?.solicitation_subtype?.label" 
          [msgErr]="CONTENT_BOUNDS?.solicitation_subtype?.msgErr">
          <input
          [placeholder]="CONTENT_BOUNDS?.solicitation_subtype?.initialOption"
            type="text"
            voxelInput
            voxelAutocomplete
            #filterSubtype="voxelAutocomplete"
            [formControlName]="CONTENT_BOUNDS?.solicitation_subtype?.formControlName"
          />
          <app-clean-autocomplete [autocomplete]="subtypesAutocomplete"></app-clean-autocomplete>
          <voxel-autocomplete #subtypesAutocomplete [input]="filterSubtype" filterMode="includes">
            <!--<voxel-option value="" [innerText]="CONTENT_BOUNDS?.solicitation_subtype?.initialOption"></voxel-option>-->
            <voxel-option *ngFor="let option of celulaSubtypesList" [value]="option.id" [innerText]="option.name">
            </voxel-option>
          </voxel-autocomplete>
        </voxel-form-field>
      </div>
            
      <div class="voxel-col-4" *ngIf="showOfferMessage">
        <voxel-alert [type]="CONTENT_BOUNDS?.offer_message?.type" light class="voxel-mb-2"
            [icon]="CONTENT_BOUNDS?.offer_message?.icon">
            {{offerMessage}}
        </voxel-alert>
      </div>

      <div *ngIf="isVisible('cell_assignment')" class="voxel-col-4 voxel-border-color-soft voxel-border-small-top voxel-border-small-bottom voxel-pv-6 cell-container">
        <div class="voxel-col-2">
          <div class="voxel-row-4" style="align-items: baseline">
            <div class="voxel-col-1 voxel-text-section-02">
              <b [innerText]="CONTENT_BOUNDS?.cell_assignment?.cell_caption"></b>
            </div>
            <div class="voxel-col-2 voxel-text-body-01">
              <p>{{form.get(CONTENT_BOUNDS?.cell_assignment?.formControlName)?.value?.name}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Traslados  -->
      <div class="voxel-col-4 section" *ngIf="form.get(CONTENT_BOUNDS.solicitation_subtype?.formControlName)?.value === 'TRA000'">
        <div class="title-section actions">

          <b class="title" [innerText]="CONTENT_BOUNDS?.caption_main"></b>
          <button #addTransferModal="voxelOverlayOrigin"
          voxelOverlayOrigin voxelButtonContextual buttonStyle="secondary"
            (click)="modal('B')">{{this.CONTENT_BOUNDS?.buttons?.add_transfer_button?.caption}}</button>
        </div>

        <div id="transferInfo" class="voxel-col-12">
          <vcl-table>
            <table cdk-table [dataSource]="transfers?.value || []">
              <ng-container cdkColumnDef="TipoTraslado">
                <th cdk-header-cell *cdkHeaderCellDef> Tipo de traslado </th>
                <td cdk-cell *cdkCellDef="let element"> {{element?.transferType}}</td>
              </ng-container>
              <ng-container cdkColumnDef="TipoProducto">
                <th cdk-header-cell *cdkHeaderCellDef> Tipo de producto </th>
                <td cdk-cell *cdkCellDef="let element"> {{element?.productType}} </td>
              </ng-container>
              <ng-container cdkColumnDef="Valor">
                <th cdk-header-cell *cdkHeaderCellDef> Valor </th>
                <td cdk-cell *cdkCellDef="let element"> {{element?.values}} </td>
              </ng-container>
              <ng-container cdkColumnDef="Opcion">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let action; index as i;" class="voxel-icon--secondary">
                  <div class="voxel-row-4 voxel-icon--secondary">
                    <voxel-icon size="S" class="voxel-col-2" (click)="modal('B', i, action)" type="secondary">editar_outline</voxel-icon>
                    <voxel-icon size="S" class="voxel-col-2" (click)="modal('A', i, action)" type="secondary">excluir_outline</voxel-icon>
                  </div>
                </td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns;"></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </vcl-table>
          <div class="voxel-border-small" *ngIf="transfers?.value?.length===0">Debes registrar al menos un traslado, para comenzar <button voxelButtonAction buttonStyle=secondary (click)="this.modal('B')"><u>{{this.CONTENT_BOUNDS?.buttons?.add_initial?.caption}}</u></button></div>

          <div class="alert-container voxel-col-12" *ngIf="transfer?.invalid && transfers?.value?.length > 0">
            <voxel-alert [type]="CONTENT_BOUNDS?.transfer_edit?.transfer_error_notification?.type" light class="voxel-mb-2"
                [icon]="CONTENT_BOUNDS?.transfer_edit?.transfer_error_notification?.icon">
                <p>{{CONTENT_BOUNDS?.transfer_edit?.transfer_error_notification?.text}}</p>
                <ul class="list-error">
                  <li class="item-list-error" *ngFor="let error of (errorMessageTransfer(transfer.controls[0]) | async) || []">
                    {{error}}
                  </li>
                </ul>
            </voxel-alert>
          </div>

        </div>

      </div>

      <div class="voxel-col-2">
        <voxel-form-field [label]="requireCurrency?CONTENT_BOUNDS.solicitation_value.label+' (*)':CONTENT_BOUNDS.solicitation_value.label" [msgErr]="CONTENT_BOUNDS.solicitation_value.msgErr">
          <input voxelInput voxelMask="currency" [config]="config" [formControlName]="CONTENT_BOUNDS.solicitation_value.formControlName"
          class="voxel-col-2" live
          name="{{CONTENT_BOUNDS.solicitation_value.name}}"/>
        </voxel-form-field>
      </div>
    </div>

    <div class="voxel-col-12" *ngIf="datasource1?.solicitations?.length > 0" >
      <div class="voxel-col-12">
      </div>
      <div class="voxel-col-12" *ngIf="this.datasource1?.solicitations?.length" >
        <voxel-modal [modalOrigin]="solicitationData" *ngIf="this.datasource1?.solicitations" id="modal-A"
          (modalClose)="datasource1.close($event)" [modalIsOpen]="datasource1.modalAShow" modalCloseLabel="Entendido"
          modalTitle="{{this.CONTENT_BOUNDS.solicitationsDetails.modalTitle}}" modalLang="es"
          modalAriaLabelledby="cuil-title" modalClass="modal-spanish">
          <p class="voxel-text-title-01 voxel-pb-7" [textContent]="this.CONTENT_BOUNDS.exists_notification.caption"></p>
          <p class="voxel-text-subtitle-01" [textContent]="this.CONTENT_BOUNDS.exists_notification.label"></p>
          <div class="voxel-col-12 voxel-pb-2">
            <vcl-table>
              <table cdk-table [dataSource]="datasourceDuplicity" vclSort (sortData)="datasource1.sortData($event)" >
                <ng-container *ngFor="let title of datasource1.displayedColumns" [cdkColumnDef]="title.key">
                  <div *ngIf="title.sort===true">
                    <th cdk-header-cell *cdkHeaderCellDef [textContent]="title.value" vclSortColumn [columnName]="title.key"></th>
                  </div>
                  <div *ngIf="title.sort===false">
                    <th cdk-header-cell *cdkHeaderCellDef [textContent]="title.value" [columnName]="title.key"></th>
                  </div>
                  <div *ngIf="title.key==='FechaRadicacion'">
                    <td cdk-cell *cdkCellDef="let element" [textContent]="element[title.key] | date:'dd-MM-yyyy'"></td>
                  </div>
                  <div *ngIf="title.key!=='Soportes' && title.key!=='FechaRadicacion'">
                    <td cdk-cell *cdkCellDef="let element" [textContent]="element[title.key]"></td>
                    <!-- {{element[title.key]}}  -->
                  </div>
                  <div *ngIf="title.key==='Soportes'">
                    <td cdk-cell *cdkCellDef="let element">
                      <ul>
                        <li *ngFor="let oten of element.Soportes">
                          <a href="" [textContent]="oten.name"></a>
                        </li>
                      </ul>
                    </td>
                  </div>
                </ng-container>
                <tr cdk-header-row *cdkHeaderRowDef="datasource1.displayedColumnsList"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: datasource1.displayedColumnsList;"></tr>
                </table>
                <vcl-paginator (page)="datasource1.onPageChange($event)" [length]="datasource1.dataLength"
                [pageIndex]="datasource1.pageIndex" [pageSize]="datasource1.pageSize" [showPageSelect]="true"
                language="es" [pageSizeOptions]="datasource1.pageSizeOptions">
              </vcl-paginator>
            </vcl-table>
          </div>
          <div voxelModalFooter>
            <button voxelButton (click)="datasource1.close($event)">Entendido</button>
          </div>
        </voxel-modal>


        <div id="transferInfo" class="voxel-col-12 container-over">
          <voxel-dialog [id]="'dialog-a'" [dialogIsOpen]="datasource1.modalBShow">
            <p>{{this.CONTENT_BOUNDS.confirmDelete.message}}</p>
            <div voxelDialogFooter>
              <button voxelButtonContextual (click)="datasource1.close({type:'action1'}, 'actionOk')">
                Cancelar
              </button>
              <button voxelButtonContextual (click)="datasource1.close({type:'action2'}, 'actionOk')">
                Aceptar
              </button>
            </div>
          </voxel-dialog>
        </div>
      </div>
      <voxel-alert type=warning light class="voxel-mb-2">
        <span>{{this.CONTENT_BOUNDS.exists_notification.text}}
          <button voxelButtonAction buttonStyle="secondary" (click)="datasource1.modal('A',0)" [textContent]="this.CONTENT_BOUNDS.exists_notification.link"></button>
        </span>
      </voxel-alert>
    </div>


  <div *ngIf="typeSubtypeForm" class="voxel-row-4">
    
    <div class="voxel-col-12">
      <app-upload-files #uploadFiles [config]="CONTENT_BOUNDS?.file_list" [requiredDoc]="requireDocument" [fileList]="fileList" [data]="fileData"></app-upload-files>
    </div>
    
    <div class="voxel-col-12">
      <b class="voxel-text-section-02 voxel-pb-1">{{requireComment?CONTENT_BOUNDS.annotations.caption+' (*)':CONTENT_BOUNDS?.annotations?.caption}}</b>
      <div class="voxel-col-12" [formGroup]="form">
        <voxel-form-field [label]="CONTENT_BOUNDS?.annotations?.label" [description]="tagnote" [msgErr]="CONTENT_BOUNDS?.annotations?.msgErr">
          <textarea voxelInput rows="2" cols="3" [placeholder]="CONTENT_BOUNDS?.annotations?.description"
            [formControlName]="CONTENT_BOUNDS?.annotations?.formControlName" (blur)="cleanCRLFEndValue($event)">
          </textarea>
        </voxel-form-field>
      </div>
    </div>
    <div class="voxel-col-12">
      <span *ngIf="requireComment||requireCurrency" class="require-label">{{CONTENT_BOUNDS?.requireField?.label}}</span>
    </div>
  </div>
</form>
</div>
<button #solicitationData="voxelOverlayOrigin" class="voxel-opacity-empty" voxelOverlayOrigin voxelButtonContextual
buttonStyle="secondary" (click)="datasource1.close($event)"></button>

<!-- Modal Traslados -->
<voxel-modal
    id="modal-b"
    [modalIsOpen]="modalBShow"
    (modalClose)="close({type:'secondary'}, 'formTransfer')"
    modalAriaLabelledby="transfers-modal-title"
    [modalOrigin]="addTransferModal"
    *ngIf="CONTENT_BOUNDS && !isLoading"
  >
      <h3 id="transfers-modal-title">{{modalCaption}}</h3>
      <div class="stepper-label"><em>{{modalDescriptionCaption}}</em></div>
      <br>
      <form [formGroup]="formTransferModal">

        <div class="voxel-row-4">
          <div class="voxel-col-2">
            <voxel-form-field *ngIf="CONTENT_BOUNDS?.transfer_edit?.transferType; let control;" [label]="control?.label" [msgErr]="(getMessageError(formTransferModal, control, formTransferModal.get(control?.formControlName)?.errors) | async) || control?.msgErr">
              <voxel-select [formControlName]="CONTENT_BOUNDS?.transfer_edit?.transferType?.formControlName">
                <voxel-option value="">Seleccione una opción</voxel-option>
                <voxel-option *ngFor="let value of this.transferTypeList" [value]="value.id">
                  {{ value.name }}
                </voxel-option>
              </voxel-select>
            </voxel-form-field>
          </div>
        </div>
      </form>

      <div voxelModalFooter="inline">
        <button
          voxelButton
          buttonStyle="secondary"
          (click)="close({type:'secondary'}, 'formTransfer')"
        >
          Cerrar
        </button>

        <button voxelButton (click)="close({type:'primary'}, 'formTransfer')" [disabled]="formTransferModal.invalid">
          Guardar
        </button>
      </div>
  </voxel-modal>


  <vcl-snack-bar label1="El traslado fue eliminado correctamente" [SnackBarConfig]="{duration:5000}">
    <div class="voxel-color-text-highlight">
      El traslado fué eliminado correctamente
      <b class="voxel-color-text-highlight">El traslado fué eliminado correctamente</b>
    </div>
  </vcl-snack-bar>
